import { Helmet } from 'react-helmet-async';
import { pick } from '../lib/content';

export default function PageMeta({ page }) {
  if (!page) return null;

  // Scraped values win verbatim. Never invent missing meta fields on archived/source pages.
  const title = pick(page.seo_title) || (page.source_url ? pick(page.title) : page.path === '/' ? 'Salon K9' : `${pick(page.title)} - Salon K9`);
  const description = pick(page.seo_description);
  const ogTitle = pick(page.og_title);
  const ogDescription = pick(page.og_description);
  const ogImage = page.og_image?.[0];
  const twitterImage = page.twitter_image?.[0];
  const canonical = page.canonical_url ? new URL(page.canonical_url, window.location.origin).href : '';

  return (
    <Helmet htmlAttributes={{ lang: page.language || 'da' }}>
      {title && <title>{title}</title>}
      {description && <meta name="description" content={description} />}
      {ogTitle && <meta property="og:title" content={ogTitle} />}
      {ogDescription && <meta property="og:description" content={ogDescription} />}
      {ogImage && <meta property="og:image" content={ogImage} />}
      {page.twitter_card && <meta name="twitter:card" content={page.twitter_card} />}
      {twitterImage && <meta name="twitter:image" content={twitterImage} />}
      {canonical && <link rel="canonical" href={canonical} />}
    </Helmet>
  );
}
